import tacklebox from "tacklebox";

function Page(id = null, title = "") {
    tacklebox.design.Page.call(this, id, title);
}
tacklebox.design.extend(Page, tacklebox.design.Page);

export { Page }